import third from './third'

export { third }